<template>
  <div class="lx-exam-batch-row">
    <el-row class="lx-e-b-r-title">
      <el-col :span="14">
        <p @click="goDetails(checkRecord)">
          {{checkRecord.name}}
          <el-button size="mini" type="primary" round v-if="checkRecord.status === 1" class="lx-check-record-tag">未开始</el-button>
          <el-button size="mini" type="success" round v-if="checkRecord.status === 2" class="lx-check-record-tag">进行中</el-button>
        </p>
        <p class="lx-font-color-helper">考核时间：{{checkRecord.startTime | formatHour}} 至 {{checkRecord.endTime | formatHour}}</p>
        <p class="lx-font-color-helper">
          考核对象：
          <span v-for="(obj, index) in checkRecord.checkObjectCounts" :key="index" style="margin-right: 15px;">{{obj.name}}({{obj.finishedStudent}}/{{obj.totalStudent}})</span>
        </p>
      </el-col>
      <el-col :span="10" style="text-align: right;">
        <i class="el-icon-delete" v-if="checkRecord.status !== 2" @click="deleteRecord(checkRecord)"></i>
        <el-button class="lx-no-bg-btn" type="primary" size="medium" @click="goSetting(checkRecord.id)" :disabled="checkRecord.status !== 1">考核设置</el-button>
        <el-button class="lx-no-bg-btn" type="primary" size="medium" :disabled="checkRecord.status !== 3" @click="exportScore(checkRecord.id)">导出成绩</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: ['checkRecord', 'checkSetting'],
  data () {
    return {}
  },
  mounted () {
  },
  methods: {
    goDetails (record) {
      this.$router.push({name: 'CheckDetails', params: {record}})
    },
    goSetting (id) {
      sessionStorage.setItem('recordId', id)
      sessionStorage.setItem('check', this.checkSetting)
      this.$router.push({name: 'CheckSetting'})
    },
    deleteRecord (record) {
      this.$xhrPatch(`/checks/${record.id}`).then(rs => {
        if (rs.code === 200) {
          this.$emit('delete-record', true)
        }
      })
    },
    exportScore (id) {
      window.open(`/tms/checks/${id}/export`)
    }
  }
}
</script>

<style scoped>
.lx-exam-batch-row { margin-top: 20px; border-bottom: 1px solid #f0f0f0; cursor: pointer}
.lx-no-bg-btn { background: none !important; color: #5e93f6; }
.lx-no-bg-btn.is-disabled { border: 1px solid #dddddd; color: #dddddd; }
.lx-e-b-r-title i { font-size: 20px; color: #5e93f6; cursor: pointer; margin-right: 10px; vertical-align: middle; }
.lx-font-color-helper { font-size: 12px; }
.lx-e-b-r-title { padding-bottom: 10px; }
.lx-e-b-r-title .lx-font-color-helper { margin-top: 15px; }
</style>



// WEBPACK FOOTER //
// src/components/check/CheckRecords.vue